export const setList = (state, payload) => state.list = payload
export const setListTags = (state, payload) => state.listTags = payload
export const setItem = (state, payload) => state.item = payload
export const removeItem = (state, payload) => state.list.splice(payload, 1)
